// extracted by mini-css-extract-plugin
export default {"buttonAction":"SubrentalsVendorTab_buttonAction__evj6X","vendorTable":"SubrentalsVendorTab_vendorTable__487qL"};